/* eslint-disable */

import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import {
  COMMAND_PRIORITY_EDITOR,
  createCommand,
  LexicalCommand
} from "lexical";

import { useEffect } from "react";
import { CasLexicalInputNumberNode } from "../CasLexicalNumber/CasLexicalInputNumberNode";
import { SHOW_NUMBER_INPUT_DIALOG_COMMAND } from "./CasNumberBoxDialogHandlerPlugin";

export const INSERT_NUMBER_BOX_COMMAND: LexicalCommand<void> = createCommand();

export default function CasLexicalInputNumberPlugin(): null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!editor.hasNodes([CasLexicalInputNumberNode])) {
      throw new Error("NumberBoxNode not registered on editor");
    }

    return editor.registerCommand(
      INSERT_NUMBER_BOX_COMMAND,
      () => {
        editor.dispatchCommand(SHOW_NUMBER_INPUT_DIALOG_COMMAND, undefined);
        return true;
      },
      COMMAND_PRIORITY_EDITOR
    );
  }, [editor]);

  return null;
}
